import { useEffect, useRef } from 'react'

import {
  BubbleItem,
  BubbleValue,
  BubbleMaxValue,
  BubbleContainer,
  BubbleItemFilled,
  BubbleInfoWrapper,
  BubbleDescription,
  BubbleValueWrapper,
  BubbleCircleWrapper,
  BubbleItemFillWrapper,
  BubbleCirclePercentage
} from '../../dashboard-jetty.styled'
import { _getBubbleRightPositions } from '../../dashboard-jetty.helper'
export const Bubbles = ({ data, vesselSize }) => {
  const elementRef = useRef()

  const updateScale = () => {
    const rightPosition = _getBubbleRightPositions(vesselSize)

    if (elementRef.current) {
      elementRef.current.style.right = rightPosition
    }
  }

  useEffect(() => {
    updateScale()
    window.addEventListener('resize', updateScale)
    return () => window.removeEventListener('resize', updateScale)
  }, [])

  return (
    <BubbleContainer width='7rem' ref={elementRef}>
      <BubbleItem>
        <BubbleCircleWrapper percentage={data?.Percentage}>
          <BubbleCirclePercentage>{data?.Percentage}%</BubbleCirclePercentage>
        </BubbleCircleWrapper>
        <BubbleInfoWrapper>
          <BubbleDescription>
            <BubbleValueWrapper>
              <BubbleValue>{data?.Actual}/</BubbleValue>
              <BubbleMaxValue>{data?.Stowage_Plan}</BubbleMaxValue>
            </BubbleValueWrapper>
          </BubbleDescription>
          <BubbleItemFillWrapper>
            <BubbleItemFilled percentage={data?.Percentage} />
          </BubbleItemFillWrapper>
        </BubbleInfoWrapper>
      </BubbleItem>
    </BubbleContainer>
  )
}
